import { DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import SubmitButton from "./button/SubmitButton"
import { useDispatch } from 'react-redux'
import { closeModal } from "../store/actions/modalAction"

const MessageDilog = ({ title = "Error", message, onSubmit }) => {
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(closeModal())
    }
    return (
        <>
            <DialogTitle variant="h4">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText variant="h6" id="alert-dialog-slide-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <SubmitButton variant="outlined" onClick={handleClose} title={'close'}></SubmitButton>
                <SubmitButton onClick={onSubmit ? onSubmit : handleClose} title="okay" ></SubmitButton>
            </DialogActions>

        </>
    )
}
export default MessageDilog